import React, { FunctionComponent } from 'react';

import { useUnit } from 'effector-react/ssr';

import { $dialogs, setIsOpenDevelop } from '@stores/dialogs';

import { applyTypograf } from '@utils/typograf';

import { Dialog } from '@components/common/Dialog/Dialog';
import { InformingBlock } from '@components/common/InformingBlock/InformingBlock';

import styles from './DevelopDialog.module.scss';

export const DevelopDialog: FunctionComponent = () => {
    const [{ isOpenDevelop }, setIsOpenDevelopFn] = useUnit([$dialogs, setIsOpenDevelop]);
    return (
        <Dialog
            isOpen={isOpenDevelop}
            setOpen={setIsOpenDevelopFn}
            classes={{ content: styles.dialogContent }}
        >
            <InformingBlock
                icon="develop"
                title={{
                    text: applyTypograf('Этот раздел ещё в разработке') as string,
                    element: 'h2',
                }}
                className={styles.informing}
                isAnimatedEnter={false}
            />
        </Dialog>
    );
};
